import { Build, Component, h, Host, Prop, State } from '@stencil/core';
import { parseInline } from 'marked';
import { unserialize } from '../../..';
import { getInstance } from '../../../services/funnels/funnel-data.service';

interface OptionLike {
    label: string;
    value: string;
    supported: boolean;
    message: string;
}

@Component({
    tag: 'web-select-funnel-entrance',
    styleUrl: 'select-funnel-entrance.scss',
    shadow: false
})
export class SelectFunnelEntrance {
    @Prop() funnelUrl: string;
    @Prop() buttonText: string;
    @Prop() placeholderText: string;
    @Prop() options: string;
    @Prop() dataType: string;
    @Prop() hideInput: boolean;

    @State() listOptions: OptionLike[];
    @State() selectedIndex: number;
    @State() canSubmit: boolean;
    @State() message: string;

    async componentWillLoad() {
        this.listOptions = this.options ? (unserialize(this.options) as OptionLike[]) : [];

        if (Build.isBrowser) {
            const funnelService = getInstance<string>();
            const storedValue = await funnelService.getStoredValue(this.dataType);

            const option = this.listOptions.find(({ value }) => value === storedValue);
            this.selectedIndex = this.listOptions.indexOf(option);
        }
    }

    async componentWillRender() {
        const { selectedIndex } = this;
        const option = this.listOptions[selectedIndex];

        this.canSubmit = !(option?.supported === false);
        this.message = option?.message ? await parseInline(option?.message) : undefined;
    }

    public handleSubmit = async (event: Event) => {
        event.preventDefault();

        const funnelService = getInstance<string>();
        const form = event.target as HTMLFormElement;
        const value = form.selectedValue?.value;

        funnelService.submitValue(this.dataType, value, this.funnelUrl);
    };

    public async handleChange(event: Event) {
        const select = event.target as HTMLSelectElement;
        this.selectedIndex = select.selectedIndex - 1;
    }

    render() {
        const { buttonText, listOptions, selectedIndex, canSubmit, message, placeholderText, hideInput } = this;

        return (
            <Host>
                <form onSubmit={(e) => this.handleSubmit(e)}>
                    {hideInput !== true && (
                        <div class="fieldset">
                            <div class="select">
                                <label htmlFor="form-selected-value" class="screen-reader-only">
                                    {placeholderText}
                                </label>
                                <select
                                    id="form-selected-value"
                                    name="selectedValue"
                                    title={placeholderText}
                                    class={selectedIndex < 0 ? 'no-value' : ''}
                                    onChange={(e) => this.handleChange(e)}
                                >
                                    <option disabled hidden selected>
                                        {placeholderText}
                                    </option>
                                    {listOptions.map(({ label, value }, index) => (
                                        <option value={value} selected={selectedIndex === index}>
                                            {label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}
                    <div class="fieldset">
                        <web-button disabled={!canSubmit} buttonText={buttonText}></web-button>
                    </div>
                </form>
                {message && <div class="web-balloon top-left" innerHTML={message}></div>}
            </Host>
        );
    }
}
